import { Fragment } from 'react';
import styled from 'foundations-theming/utils';
import { useTheme } from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { device } from '../../constants/StyledComponentConstants';
// @ts-expect-error Could not find a declaration file for module
import useMediaQuery from '../../hooks/useMediaQuery';
import CatalogDropdownContainer from '../CatalogDropdown/CatalogDropdownContainer';
// @ts-expect-error Could not find a declaration file for module
import blobsImageUrl from 'bender-url!../../../images/storefront-header-blobs.svg';
import { useSearchWithAutocompleteContext } from '../../features/autocomplete/components/SearchInputWithAutocompleteProvider';
import { MainSearchWithAutocompleteInput } from '../../features/autocomplete/components/MainSearchWithAutocompleteInput';
import { MainSearchInputWithAutocompleteProvider } from '../../features/autocomplete/components/MainSearchInputWithAutocompleteProvider';
import ACSkeletonBox from 'academy-common-lib/components/loading/ACSkeletonBox';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StylesHeader = styled.div.withConfig({
  displayName: "HeadingNav__StylesHeader",
  componentId: "sc-1rdjrtz-0"
})(["background:", ";background-image:url(", "),linear-gradient( to right,", ",", " );background-position:center center;background-repeat:no-repeat;background-size:auto 100%;color:", ";text-align:center;padding:40px 16px 0;", " @media screen and ", "{padding-top:14px;padding-bottom:1px;background-image:none;}"], ({
  theme
}) => theme.color['fill-accent-teal-default'], blobsImageUrl, ({
  theme
}) => theme.color['fill-accent-teal-pressed'], ({
  theme
}) => theme.color['fill-accent-teal-default'], ({
  theme
}) => theme.color['text-core-default'], props => props.stickySearch && ` @media screen and ${device.not.mobile} {
        position: sticky;
        height: 260px;
        top: -130px;
        z-index: 4;
    }`, device.mobile);
const StylesHeaderInner = styled.div.withConfig({
  displayName: "HeadingNav__StylesHeaderInner",
  componentId: "sc-1rdjrtz-1"
})(["@media screen and ", "{height:140px;", "}"], device.not.mobile, props => props.stickySearch && ` @media screen and ${device.not.mobile} {
          position: sticky;
          top: -36px;
    }`);
const SearchContainerResponsive = styled.div.withConfig({
  displayName: "HeadingNav__SearchContainerResponsive",
  componentId: "sc-1rdjrtz-2"
})(["max-width:492px;margin:0 auto;"]);
const SearchContainer = styled.div.withConfig({
  displayName: "HeadingNav__SearchContainer",
  componentId: "sc-1rdjrtz-3"
})(["width:492px;max-width:492px;margin-left:20px;"]);
export const HeaderTextLoadingSkeleton = ({
  width,
  height
}) => {
  const theme = useTheme();
  return /*#__PURE__*/_jsx(ACSkeletonBox, {
    animated: true,
    backgroundcolor: theme.color['fill-accent-blue-default'],
    "data-test-id": "header-text-loading-skeleton",
    shimmercolor: theme.color['fill-accent-blue-hover'],
    style: {
      display: 'inline-block',
      height,
      width
    }
  });
};
const InnerHeadingNav = ({
  titleKey,
  withSearch,
  icon,
  titleText,
  subtitleText
}) => {
  const {
    clearSearch
  } = useSearchWithAutocompleteContext();
  const isMobile = useMediaQuery(`screen and ${device.mobile}`);
  const getHeadingText = () => {
    if (!titleText && !titleKey) {
      return /*#__PURE__*/_jsx(HeaderTextLoadingSkeleton, {
        height: "24px",
        width: "300px"
      });
    }
    return titleText || /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.heading.headingTitles.${titleKey}`
    });
  };
  const getSubtitleText = () => {
    if (!subtitleText && !titleKey) {
      return /*#__PURE__*/_jsx(HeaderTextLoadingSkeleton, {
        height: "16px",
        width: "500px"
      });
    }
    return subtitleText || /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.heading.headingSubTitles.${titleKey}`
    });
  };
  const desktopHeading = /*#__PURE__*/_jsx(Text, {
    as: "h1",
    use: "on-dark",
    children: getHeadingText()
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: isMobile ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h4",
        use: "on-dark",
        children: getHeadingText()
      }), withSearch &&
      /*#__PURE__*/
      // @bend-expect trellis-tokenized
      _jsxs(SearchContainerResponsive, {
        children: [/*#__PURE__*/_jsx(MainSearchWithAutocompleteInput, {}), /*#__PURE__*/_jsx(CatalogDropdownContainer, {
          onOptionClick: clearSearch
        })]
      })]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [icon ? /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "500",
        justifyContent: "center",
        marginBlockEnd: "400",
        children: [icon, desktopHeading]
      }) : desktopHeading, /*#__PURE__*/_jsx(Text, {
        as: "p",
        marginBlockEnd: withSearch ? '400' : undefined,
        marginBlockStart: withSearch ? '300' : '400',
        typography: "body-300",
        use: "on-dark",
        children: getSubtitleText()
      }), withSearch && /*#__PURE__*/_jsxs(Flex, {
        alignItems: "start",
        justifyContent: "center",
        marginBlockStart: "100",
        children: [/*#__PURE__*/_jsx(CatalogDropdownContainer, {
          buttonSize: "large",
          onOptionClick: clearSearch
        }), /*#__PURE__*/_jsx(SearchContainer, {
          children: /*#__PURE__*/_jsx(MainSearchWithAutocompleteInput, {})
        })]
      })]
    })
  });
};
const HeadingNav = ({
  hideStylesHeader,
  titleKey,
  withSearch,
  icon,
  titleText,
  subtitleText
}) => {
  const WrapperComponent = withSearch ? MainSearchInputWithAutocompleteProvider : Fragment;
  return /*#__PURE__*/_jsx(WrapperComponent, {
    children: !hideStylesHeader &&
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(StylesHeader, {
      stickySearch: withSearch,
      children: /*#__PURE__*/_jsx(StylesHeaderInner, {
        stickySearch: withSearch,
        children: /*#__PURE__*/_jsx(InnerHeadingNav, {
          icon: icon,
          subtitleText: subtitleText,
          titleKey: titleKey,
          titleText: titleText,
          withSearch: withSearch
        })
      })
    })
  });
};
export default HeadingNav;